"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTimeCodeApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var OneTimeCodeApi = /** @class */ (function (_super) {
    __extends(OneTimeCodeApi, _super);
    function OneTimeCodeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Sends a one time code email to the specified email address.
     * Provides endpoint for sending a one time code to users for enrollment.
     */
    OneTimeCodeApi.prototype.sendOneTimeCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sendOtcRequest === null || requestParameters.sendOtcRequest === undefined) {
                            throw new runtime.RequiredError('sendOtcRequest', 'Required parameter requestParameters.sendOtcRequest was null or undefined when calling sendOneTimeCode.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/one-time-code",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SendOtcRequestToJSON(requestParameters.sendOtcRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sends a one time code email to the specified email address.
     * Provides endpoint for sending a one time code to users for enrollment.
     */
    OneTimeCodeApi.prototype.sendOneTimeCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendOneTimeCodeRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks the validity of the provided one time code. >  Validation Error Codes:   * `OTC_EXPIRED`   * `OTC_ALREADY_VERIFIED`   * `OTC_NOT_PRESENT`
     * Endpoint for users to verify one time code.
     */
    OneTimeCodeApi.prototype.verifyOneTimeCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.verifyOtcRequest === null || requestParameters.verifyOtcRequest === undefined) {
                            throw new runtime.RequiredError('verifyOtcRequest', 'Required parameter requestParameters.verifyOtcRequest was null or undefined when calling verifyOneTimeCode.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/one-time-code",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.VerifyOtcRequestToJSON(requestParameters.verifyOtcRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.VerifyOtcResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Checks the validity of the provided one time code. >  Validation Error Codes:   * `OTC_EXPIRED`   * `OTC_ALREADY_VERIFIED`   * `OTC_NOT_PRESENT`
     * Endpoint for users to verify one time code.
     */
    OneTimeCodeApi.prototype.verifyOneTimeCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyOneTimeCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OneTimeCodeApi;
}(runtime.BaseAPI));
exports.OneTimeCodeApi = OneTimeCodeApi;
